import React from 'react'
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import {getSymbol as getCurrencySymbol} from './currency';

interface CurrencyFormatProps extends Omit<NumberFormatProps, 'onChange'> {
    inputRef?: (el: HTMLInputElement) => void;
    onChange: (event: { target: { value: string } }) => void;
    currencyCode?: string;
}

function CurrencyFormat(props: CurrencyFormatProps) {
    const { inputRef, onChange, currencyCode, ...other } = props;
    let currencyPrefix = getCurrencySymbol(currencyCode) || "$";
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={currencyPrefix}
      />
    );
}

interface ExtendedTextFieldProps {
    input: {
        name?: string;
        onChange?: (...args: any[]) => void;
        value?: any;
        [key: string]: any;
    };
    meta: {
        error?: any;
        touched?: boolean;
        data?: { warning?: any; [key: string]: any };
        [key: string]: any;
    };
    alwaysShowError?: boolean;
    currency?: boolean;
    currencyCode?: string;
    endAdornment?: React.ReactNode;
    helperText?: React.ReactNode;
    error?: any;
    [key: string]: any;
}

const ExtendedTextField = React.memo(function ExtendedTextField(props: ExtendedTextFieldProps) {
    let {
      input: { name, onChange, value, ...restInput },
      meta,
      alwaysShowError,
      currency,
      currencyCode,
      endAdornment,
      helperText,
      ...rest
  } = props;
    restInput.endAdornment = endAdornment;
    if(currency){
        restInput.inputProps = {currencyCode: currencyCode, ...restInput.inputProps};
    }
    restInput.autoComplete = "off";
    let error = meta.error || props.error;
    if(meta && meta.data && meta.data.warning){
        if(!error || error === true){
            error = meta.data.warning;
        } else {
            error += "\n" + meta.data.warning;
        }
    }
    helperText = (meta.touched || alwaysShowError) && error ? error : helperText;
    if(error === true){
        helperText = undefined;
    }
    return (
        <TextField
            {...rest}
            variant='standard'
            name={name}
            helperText={helperText}
            error={!(!(error && (meta.touched || alwaysShowError)))}
            onChange={onChange}
            value={value}
            InputProps={(currency ? {inputComponent: CurrencyFormat, notched: true, ...restInput} : {notched: true, ...restInput}) as any}
            InputLabelProps={{shrink: true}}
        />
    );
});

export default ExtendedTextField;

interface FakeFieldProps {
    label?: React.ReactNode;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

function FakeField(props: FakeFieldProps) {
    return <FormControl>
      {!(!props.label) && <InputLabel shrink>{props.label}</InputLabel>}
      <div style={{height: "1.1875em", padding: "6px 0 7px", textAlign: 'left', marginTop: "16px", whiteSpace: 'nowrap', overflow: 'hidden', ...props.style}}>{props.children}</div>
    </FormControl>
}

export { FakeField };
